import { app } from "@microsoft/teams-js";
import { TeamsSurveyTypes } from "@teams/types";
import { QuestionnaireTemplateDTO } from "@teams/types/api";
import { useCallback, useState } from "react";

import { useUserInfo } from "../../_shared/actions/useUserInfo";
import { FetchResult, isError } from "../../_shared/services/ChannelApi";
import { templatesApi } from "../../_shared/services/TemplatesApi";
import { clientEventTracker } from "../../_shared/utils/clientTelemetry";

export const useTemplates = () => {
  const [isTemplatesLoading, setIsTemplatesLoading] = useState<boolean>(true);
  const [templates, setTemplates] = useState<QuestionnaireTemplateDTO[]>([]);
  const [templatesError, setTemplatesError] = useState<Error>();
  const { user } = useUserInfo();

  const loadTemplates = useCallback(
    async (
      context: app.Context,
      scope: "global" | "personal",
      surveyTypes?: TeamsSurveyTypes[]
    ) => {
      setIsTemplatesLoading(true);
      setTemplatesError(undefined);

      let templatesResponse: FetchResult<QuestionnaireTemplateDTO[]>;

      if (scope === "global") {
        templatesResponse = await templatesApi.getGlobalTemplates(context);
      } else {
        templatesResponse = await templatesApi.getPersonalTemplates(
          context,
          surveyTypes || ["poll", "survey", "quiz"]
        );
      }

      setIsTemplatesLoading(false);
      if (isError(templatesResponse)) {
        clientEventTracker.track("loadtemplates/error", user, {
          error: templatesResponse,
          url: window.location.pathname,
          tenantId: context?.user?.tenant?.id,
          type: context.channel?.id ? "channel" : "groupChat",
          channel: context.channel?.id || context.chat?.id,
        });
        setTemplatesError(templatesResponse);
        return;
      }

      setTemplates(templatesResponse);
    },
    [setIsTemplatesLoading, setTemplates, setTemplatesError] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return { templatesError, loadTemplates, isTemplatesLoading, templates, setTemplates };
};
